module.exports = "<footer class=\"footer\">\n    <div class=\"footer__container\">\n        <div class=\"footer__logo\">\n            <a routerLink=\"/home\">\n                <img src=\"./assets/logo.png\" alt=\"\">\n            </a>\n        </div>\n        <div class=\"footer__copyright\">\n            <a href=\"http://www.augmentar.am\" target=\"_blank\">\n                ./ on time by AugmentAr CJSC\n            </a>\n        </div>\n    </div>\n</footer>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/footer/footer.component.html
// module id = ./src/app/shared/footer/footer.component.html
// module chunks = main